/** Phase E-1: HomeTab, MoreTab, CatalogTab — ko/en/vi/ru */

const home = {
  completeProfileCta: ['완성하러 가기 →', 'Complete profile →', 'Hoàn thiện hồ sơ →', 'Заполнить профиль →'],
  priorityTitle: ['우선 처리', 'Priority', 'Ưu tiên', 'Приоритет'],
  priorityInquiry: ['미응답 문의', 'Unanswered inquiries', 'Tin nhắn chưa trả lời', 'Неотвеченные запросы'],
  priorityInquiryHint: ['채팅·문의함 확인', 'Check chat & inbox', 'Kiểm tra chat & hộp thư', 'Чат и входящие'],
  priorityBooking: ['예약 대기', 'Pending bookings', 'Đặt chỗ chờ duyệt', 'Ожидающие брони'],
  priorityBookingHint: ['승인·배정 필요', 'Needs approval', 'Cần phê duyệt', 'Нужно подтверждение'],
  priorityOrder: ['미접수 주문', 'Pending orders', 'Đơn chờ nhận', 'Ожидающие заказы'],
  priorityOrderHint: ['접수·배차 필요', 'Needs accepting', 'Cần xác nhận', 'Требуется подтверждение'],
  priorityReview: ['리뷰 미응답', 'Reviews without reply', 'Đánh giá chưa trả lời', 'Отзывы без ответа'],
  priorityReviewHint: ['답글 작성', 'Write a reply', 'Viết phản hồi', 'Написать ответ'],
  priorityApplicants: ['신규 지원자', 'New applicants', 'Ứng viên mới', 'Новые кандидаты'],
  priorityApplicantsHint: ['지원자 확인 필요', 'Review new applicants', 'Cần xem ứng viên', 'Нужно просмотреть кандидатов'],
  countUnit: ['{n}건', '{n}', '{n}', '{n}'],
  todayTitle: ['오늘 현황', 'Today', 'Hôm nay', 'Сегодня'],
  todayPendingBookings: ['📅 대기 예약', '📅 Pending bookings', '📅 Đặt chỗ chờ', '📅 Ожидающие брони'],
  todayUnreadChats: ['💬 미읽음 문의', '💬 Unread chats', '💬 Tin chưa đọc', '💬 Непрочитанные'],
  todayPendingOrders: ['🛵 미접수 주문', '🛵 Pending orders', '🛵 Đơn chờ nhận', '🛵 Ожидающие заказы'],
  todayNewApplicants: ['👤 신규 지원자', '👤 New applicants', '👤 Ứng viên mới', '👤 Новые кандидаты'],
  upcomingTitle: ['다가오는 예약', 'Upcoming bookings', 'Đặt chỗ sắp tới', 'Ближайшие брони'],
  upcomingEmpty: ['대기 중인 예약이 없어요', 'No pending bookings', 'Không có đặt chỗ chờ', 'Нет ожидающих броней'],
  packageFallback: ['패키지', 'Package', 'Gói', 'Пакет'],
  participantsMeta: ['{n}명 · {date}', '{n} guests · {date}', '{n} khách · {date}', '{n} гостей · {date}'],
  statsTitle: ['통계 요약', 'Stats summary', 'Tóm tắt thống kê', 'Сводка статистики'],
  statsCardHint: [
    '매출·주문·인기메뉴 통계 보기',
    'View sales, orders & popular items',
    'Xem doanh thu, đơn hàng & món bán chạy',
    'Продажи, заказы и популярные позиции',
  ],
  statsCardHintJobs: [
    '조회수·문의 통계 보기',
    'View views & inquiry stats',
    'Xem thống kê lượt xem & câu hỏi',
    'Просмотры и статистика запросов',
  ],
  fabOpen: ['빠른 실행', 'Quick actions', 'Thao tác nhanh', 'Быстрые действия'],
  fabClose: ['빠른 실행 닫기', 'Close quick actions', 'Đóng thao tác nhanh', 'Закрыть быстрые действия'],
  quickTitle: ['바로가기', 'Quick actions', 'Truy cập nhanh', 'Быстрые действия'],
  dayUnit: ['일', '', ' ', ' '],
  profileScoreLabel: ['프로필 완성도', 'Profile score', 'Độ hoàn thiện hồ sơ', 'Заполненность профиля'],
  todayCardTitle: ['오늘', 'Today', 'Hôm nay', 'Сегодня'],
  riderManageTitle: ['배달 설정', 'Delivery settings', 'Cài đặt giao hàng', 'Настройки доставки'],
  riderManageDesc: [
    '배달 사용·반경·배달원 관리',
    'Delivery on/off, radius & riders',
    'Bật giao hàng, bán kính & tài xế',
    'Доставка, радиус и курьеры',
  ],
  businessTypeLabel: ['업종', 'Business type', 'Loại hình', 'Тип бизнеса'],
  selectedTypesAria: ['가입 시 선택한 세부 업종', 'Subcategories chosen at signup', 'Danh mục con đã chọn khi đăng ký', 'Подкатегории, выбранные при регистрации'],
  businessTypeRestaurant: ['음식점', 'Restaurant', 'Nhà hàng', 'Ресторан'],
  businessTypeMart: ['마트', 'Mart', 'Siêu thị', 'Магазин'],
  businessTypeCafe: ['카페', 'Cafe', 'Quán cà phê', 'Кафе'],
  inquiryStatusWaiting: ['상담 중', 'In progress', 'Đang tư vấn', 'В процессе'],
  inquiryStatusEmpty: ['없음', 'None', 'Không có', 'Нет'],
  chatStatusOff: ['채팅 꺼짐', 'Chat is off', 'Trò chuyện đang tắt', 'Чат отключён'],
  chatStatusLive: ['상담 가능', 'Available now', 'Sẵn sàng tư vấn', 'Готовы к чату'],
  bookingStatusWaiting: ['{n}건 대기', '{n} waiting', '{n} đang chờ', '{n} в ожидании'],
  bookingStatusEmpty: ['확인하기', 'Check', 'Kiểm tra', 'Проверить'],
  bookingStatusLive: ['예약 가능', 'Available now', 'Sẵn sàng nhận đặt chỗ', 'Готовы принимать брони'],
  orderStatusWaiting: ['{n}건 대기', '{n} waiting', '{n} đang chờ', '{n} в ожидании'],
  orderStatusEmpty: ['없음', 'None', 'Không có', 'Нет'],
  orderStatusLive: ['주문 가능', 'Accepting orders', 'Sẵn sàng nhận đơn', 'Принимаем заказы'],
  applicantsStatusWaiting: ['{n}명 대기', '{n} waiting', '{n} đang chờ', '{n} в ожидании'],
  applicantsStatusEmpty: ['확인하기', 'Check', 'Kiểm tra', 'Проверить'],
  chatRowLabel: ['채팅', 'Chat', 'Trò chuyện', 'Чат'],
  bookingRowLabel: ['예약', 'Bookings', 'Đặt chỗ', 'Брони'],
  applicantsRowLabel: ['지원자', 'Applicants', 'Ứng viên', 'Кандидаты'],
  orderRowLabel: ['주문', 'Orders', 'Đơn hàng', 'Заказы'],
  couponTitle: ['사용 가능 쿠폰', 'Available coupons', 'Mã giảm giá khả dụng', 'Доступные купоны'],
  couponEmpty: [
    '사용가능한 쿠폰이 없어요.\n카드를 눌러 쿠폰을 만들어 보세요.',
    'No coupons yet.\nTap this card to create one.',
    'Chưa có mã giảm giá.\nChạm thẻ để tạo mã.',
    'Купонов пока нет.\nНажмите карточку, чтобы создать.',
  ],
  couponPresetPercent: ['🛍 10%할인', '🛍 10% off', '🛍 Giảm 10%', '🛍 Скидка 10%'],
  couponPresetGift: ['🎁 사은품', '🎁 Free gift', '🎁 Quà tặng', '🎁 Подарок'],
  couponPresetShipping: ['📦 무료배송', '📦 Free shipping', '📦 Miễn phí ship', '📦 Бесплатная доставка'],
  couponCreating: ['만드는 중…', 'Creating…', 'Đang tạo…', 'Создание…'],
  couponCreateSuccess: ['쿠폰을 만들었어요', 'Coupon created', 'Đã tạo mã giảm giá', 'Купон создан'],
  couponCreateFail: ['쿠폰 생성에 실패했어요', 'Could not create coupon', 'Không tạo được mã', 'Не удалось создать купон'],
  couponCodeLabel: ['코드', 'Code', 'Mã', 'Код'],
  couponDeactivate: ['비활성화', 'Deactivate', 'Tắt', 'Отключить'],
  couponDelete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  couponDeleteConfirm: ['이 쿠폰을 삭제할까요?', 'Delete this coupon?', 'Xóa mã này?', 'Удалить купон?'],
  couponLabelAmount: ['{n}원 할인', '{n} off', 'Giảm {n}', 'Скидка {n}'],
  couponLabelPercent: ['{n}% 할인', '{n}% off', 'Giảm {n}%', 'Скидка {n}%'],
  couponLabelGift: ['사은품 증정', 'Free gift', 'Quà tặng', 'Подарок'],
  couponLabelShipping: ['무료배송', 'Free shipping', 'Miễn phí ship', 'Бесплатная доставка'],
  couponLabelUpgrade: ['업그레이드 증정', 'Free upgrade', 'Nâng cấp miễn phí', 'Бесплатный апгрейд'],
  couponLabelCustom: ['맞춤 쿠폰', 'Custom coupon', 'Mã tùy chỉnh', 'Свой купон'],
};

const chat = {
  filterAll: ['전체', 'All', 'Tất cả', 'Все'],
  filterUnread: ['미답변', 'Unanswered', 'Chưa trả lời', 'Без ответа'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  emptyInbox: ['아직 문의가 없어요', 'No inquiries yet', 'Chưa có câu hỏi nào', 'Пока нет обращений'],
  inquiryLabel: ['문의', 'Inquiry', 'Câu hỏi', 'Запрос'],
  noMessage: ['메시지 없음', 'No messages', 'Chưa có tin nhắn', 'Нет сообщений'],
  bannerText: [
    '라벨과 담당자를 지정해 채팅을 더 체계적으로 관리해보세요!',
    'Use labels and assignees to manage chats more systematically!',
    'Dùng nhãn và người phụ trách để quản lý trò chuyện gọn gàng hơn!',
    'Используйте метки и ответственных, чтобы упорядочить чаты!',
  ],
  responseHint: [
    '보통 -분 내 응답 · 응답률 -%',
    'Usually replies in -min · -% response rate',
    'Thường trả lời trong -phút · Tỷ lệ phản hồi -%',
    'Обычно отвечает за -мин · Доля ответов -%',
  ],
  settingsBtn: ['설정', 'Settings', 'Cài đặt', 'Настройки'],
  importantChip: ['중요', 'Important', 'Quan trọng', 'Важное'],
  filterBtn: ['필터', 'Filter', 'Bộ lọc', 'Фильтр'],
  assignChip: ['담당자 선택', 'Assign staff', 'Chọn người phụ trách', 'Назначить сотрудника'],
  selectedCount: ['{n}개 선택', '{n} selected', 'Đã chọn {n}', 'Выбрано: {n}'],
  selectRow: ['선택', 'Select', 'Chọn', 'Выбрать'],
  moreAria: ['더보기', 'More', 'Thêm', 'Ещё'],
  bulkImportant: ['중요', 'Important', 'Quan trọng', 'Важное'],
  bulkRead: ['읽음', 'Read', 'Đã đọc', 'Прочитано'],
  bulkResolve: ['상담완료', 'Resolve', 'Hoàn tất', 'Завершить'],
  bulkLeave: ['나가기', 'Leave', 'Rời khỏi', 'Покинуть'],
  bulkBlock: ['차단', 'Block', 'Chặn', 'Заблокировать'],
  bulkDone: ['처리했어요', 'Done', 'Đã xử lý', 'Готово'],
  assignDone: ['담당자를 지정했어요', 'Assignee updated', 'Đã chỉ định người phụ trách', 'Ответственный назначен'],
  resolveDone: ['상담을 완료 처리했어요', 'Marked as resolved', 'Đã đánh dấu hoàn tất', 'Отмечено как завершённое'],
  blockDone: ['채팅을 차단했어요', 'Chat blocked', 'Đã chặn trò chuyện', 'Чат заблокирован'],
  unblockDone: ['차단을 해제했어요', 'Block removed', 'Đã bỏ chặn', 'Блокировка снята'],
  leaveDone: ['채팅방을 내보냈어요', 'Left the chat', 'Đã rời khỏi trò chuyện', 'Вы покинули чат'],
  settingsSheetTitle: ['설정', 'Settings', 'Cài đặt', 'Настройки'],
  menuChatSettings: ['채팅 설정', 'Chat settings', 'Cài đặt trò chuyện', 'Настройки чата'],
  menuEditRooms: ['채팅방 편집', 'Edit chat rooms', 'Chỉnh sửa danh sách', 'Редактировать чаты'],
  menuLabels: ['채팅방 라벨 관리', 'Manage labels', 'Quản lý nhãn', 'Управление метками'],
  filterTitle: ['필터', 'Filter', 'Bộ lọc', 'Фильтр'],
  filterStatusLabel: ['상담 상태', 'Status', 'Trạng thái', 'Статус'],
  statusOption_all: ['전체', 'All', 'Tất cả', 'Все'],
  statusOption_active: ['진행중 상담', 'In progress', 'Đang tư vấn', 'В процессе'],
  statusOption_active_unread: [
    '진행중-안읽은 상담',
    'In progress - unread',
    'Đang tư vấn - chưa đọc',
    'В процессе - непрочитанные',
  ],
  statusOption_active_unanswered: [
    '진행중-미답변 상담',
    'In progress - unanswered',
    'Đang tư vấn - chưa trả lời',
    'В процессе - без ответа',
  ],
  statusOption_active_answered: [
    '진행중-답변한 상담',
    'In progress - answered',
    'Đang tư vấn - đã trả lời',
    'В процессе - отвечено',
  ],
  statusOption_resolved: ['완료된 상담', 'Resolved', 'Đã hoàn tất', 'Завершённые'],
  statusOption_blocked: ['차단된 상담', 'Blocked', 'Đã chặn', 'Заблокированные'],
  filterLabelLabel: ['라벨 선택', 'Label', 'Chọn nhãn', 'Метка'],
  filterMemberLabel: ['담당자 선택', 'Assignee', 'Người phụ trách', 'Ответственный'],
  noneSelected: ['선택 안함', 'None', 'Không chọn', 'Не выбрано'],
  memberPickerTitle: ['담당자 선택', 'Select assignee', 'Chọn người phụ trách', 'Выбор ответственного'],
  memberSearchPlaceholder: ['담당자 검색', 'Search staff', 'Tìm người phụ trách', 'Поиск сотрудника'],
  staffFallback: ['직원', 'Staff', 'Nhân viên', 'Сотрудник'],
  actionResolve: ['상담완료', 'Resolve', 'Hoàn tất', 'Завершить'],
  actionImportant: ['중요', 'Important', 'Quan trọng', 'Важное'],
  actionBlock: ['차단하기', 'Block', 'Chặn', 'Заблокировать'],
  actionUnblock: ['차단 해제', 'Unblock', 'Bỏ chặn', 'Разблокировать'],
  memoPlaceholder: [
    '메모를 입력해보세요.',
    'Add a note…',
    'Nhập ghi chú…',
    'Добавьте заметку…',
  ],
  assignedLabel: ['담당자', 'Assignee', 'Người phụ trách', 'Ответственный'],
  labelLabel: ['라벨', 'Label', 'Nhãn', 'Метка'],
  noLabel: ['라벨 없음', 'No label', 'Không có nhãn', 'Без метки'],
  actionLeave: ['채팅방 나가기', 'Leave chat room', 'Rời khỏi trò chuyện', 'Покинуть чат'],
  noLabelsYet: [
    '아직 만든 라벨이 없어요',
    'No labels yet',
    'Chưa có nhãn nào',
    'Меток пока нет',
  ],
  newLabelPlaceholder: ['새 라벨 이름', 'New label name', 'Tên nhãn mới', 'Название новой метки'],
  editLabel: ['수정', 'Edit', 'Sửa', 'Изменить'],
  deleteLabel: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  addLabel: ['추가', 'Add', 'Thêm', 'Добавить'],
};

const reviews = {
  title: ['리뷰 관리', 'Reviews', 'Quản lý đánh giá', 'Управление отзывами'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  empty: ['아직 리뷰가 없어요', 'No reviews yet', 'Chưa có đánh giá', 'Пока нет отзывов'],
  myReplyLabel: ['내 답글', 'My reply', 'Phản hồi của tôi', 'Мой ответ'],
  editBtn: ['수정', 'Edit', 'Sửa', 'Изменить'],
  replyPlaceholder: [
    '고객에게 답글을 남겨 주세요',
    'Leave a reply for the customer',
    'Để lại phản hồi cho khách hàng',
    'Оставьте ответ клиенту',
  ],
  submitBtn: ['답글 등록', 'Post reply', 'Đăng phản hồi', 'Отправить ответ'],
  submitting: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  replyRequired: ['답글 내용을 입력해 주세요.', 'Please enter a reply.', 'Vui lòng nhập phản hồi.', 'Введите текст ответа.'],
  replySuccess: ['답글이 등록됐어요.', 'Reply posted.', 'Đã đăng phản hồi.', 'Ответ отправлен.'],
  replyFail: ['답글 등록 실패', 'Could not post reply', 'Không đăng được phản hồi', 'Не удалось отправить ответ'],
};

const shorts = {
  videoOnlyError: [
    '동영상 파일만 업로드할 수 있습니다.',
    'Only video files can be uploaded.',
    'Chỉ có thể tải lên tệp video.',
    'Можно загружать только видео.',
  ],
  uploadFail: ['업로드에 실패했습니다.', 'Upload failed.', 'Tải lên thất bại.', 'Не удалось загрузить.'],
  uploadSuccess: [
    '홍보 영상이 등록되었습니다.',
    'Promo video uploaded.',
    'Đã đăng video quảng bá.',
    'Промо-видео загружено.',
  ],
  loadingLabel: ['홍보 영상 불러오는 중…', 'Loading promo videos…', 'Đang tải video quảng bá…', 'Загрузка промо-видео…'],
  errorLabel: ['목록을 불러오지 못했습니다.', 'Could not load the list.', 'Không tải được danh sách.', 'Не удалось загрузить список.'],
  retryBtn: ['다시 시도', 'Retry', 'Thử lại', 'Повторить'],
  uploadBtn: ['홍보 영상 업로드', 'Upload promo video', 'Tải video quảng bá', 'Загрузить промо-видео'],
  uploadingBtn: ['업로드 중…', 'Uploading…', 'Đang tải lên…', 'Загрузка…'],
  emptyLabel: [
    '등록된 홍보 영상이 없습니다. 업로드 버튼으로 추가해 주세요.',
    'No promo videos yet. Use the upload button to add one.',
    'Chưa có video quảng bá. Nhấn tải lên để thêm.',
    'Промо-видео пока нет. Нажмите «Загрузить», чтобы добавить.',
  ],
  videoPlaceholder: ['영상', 'Video', 'Đoạn video', 'Видео'],
  defaultTitle: ['홍보 영상', 'Promo video', 'Video quảng bá', 'Промо-видео'],
  transcodeFailHint: [
    '변환에 실패했습니다. 파일을 다시 업로드해 주세요.',
    'Conversion failed. Please upload the file again.',
    'Chuyển đổi thất bại. Vui lòng tải lại tệp.',
    'Ошибка конвертации. Загрузите файл ещё раз.',
  ],
  statusPending: ['처리 중', 'Processing', 'Đang xử lý', 'Обработка'],
  statusReady: ['노출 가능', 'Live', 'Có thể hiển thị', 'Доступно'],
  statusFailed: ['실패', 'Failed', 'Thất bại', 'Ошибка'],
};

const fab = {
  createProduct: ['상품 등록', 'Add listing', 'Đăng sản phẩm', 'Добавить товар'],
  createBooking: ['예약 열기', 'Open bookings', 'Mở đặt chỗ', 'Открыть брони'],
  createPromo: ['공동구매', 'Group buy', 'Mua chung', 'Совместная покупка'],
  createConsult: ['상담 열기', 'Open consults', 'Mở tư vấn', 'Открыть консультации'],
  createContent: ['콘텐츠 등록', 'Add portfolio', 'Thêm portfolio', 'Добавить портфолио'],
  createJob: ['공고 등록', 'Post a job', 'Đăng tuyển', 'Разместить вакансию'],
};

const more = {
  profileManage: ['프로필 관리', 'Profile', 'Hồ sơ', 'Профиль'],
  reviewsManage: ['리뷰 관리', 'Reviews', 'Đánh giá', 'Отзывы'],
  ads: ['광고 집행', 'Ads', 'Quảng cáo', 'Реклама'],
  shorts: ['AI쇼츠', 'AI shorts', 'Shorts AI', 'AI-шортс'],
  overview: ['통계', 'Statistics', 'Thống kê', 'Статистика'],
  plan: ['플랜/요금제', 'Plans & billing', 'Gói & thanh toán', 'Тарифы'],
  settlement: ['정산 관리', 'Payouts', 'Thanh toán', 'Выплаты'],
  staffManage: ['직원 계정 관리', 'Staff accounts', 'Quản lý nhân viên', 'Учётные записи персонала'],
  jobsManage: ['채용공고 관리', 'Manage job posts', 'Quản lý tin tuyển dụng', 'Управление вакансиями'],
  businessFallback: ['업체', 'Business', 'Doanh nghiệp', 'Бизнес'],
  profilePercent: ['프로필 {n}%', 'Profile {n}%', 'Hồ sơ {n}%', 'Профиль {n}%'],
  stripeTitle: ['Stripe 연동 예정', 'Stripe coming soon', 'Stripe sắp có', 'Скоро Stripe'],
  stripeLead: [
    '정산·출금 기능은 Stripe 연동 후 제공됩니다.',
    'Payouts will be available after Stripe integration.',
    'Thanh toán sẽ có sau khi tích hợp Stripe.',
    'Выплаты будут после интеграции Stripe.',
  ],
  deletionRequest: ['업체 탈퇴 요청', 'Request business deletion', 'Yêu cầu xóa doanh nghiệp', 'Удалить бизнес'],
  deletionCancel: ['탈퇴 취소', 'Cancel deletion', 'Hủy xóa', 'Отменить удаление'],
  exitHome: ['밍고 홈으로', 'Mingo home', 'Về trang chủ Mingo', 'На главную Mingo'],
  logout: ['로그아웃', 'Log out', 'Đăng xuất', 'Выйти'],
  deletionModalTitle: ['업체 탈퇴 요청', 'Delete business', 'Xóa doanh nghiệp', 'Удаление бизнеса'],
  deletionModalBody: [
    '업체를 삭제하면 30일 후 완전히 사라져요. 진행 중인 예약이 모두 완료된 후 신청할 수 있어요. 30일 내에 취소할 수 있어요.',
    'Your business will be permanently removed after 30 days. Request only after all bookings are complete. You can cancel within 30 days.',
    'Doanh nghiệp sẽ bị xóa hoàn toàn sau 30 ngày. Chỉ yêu cầu khi mọi đặt chỗ đã hoàn tất. Có thể hủy trong 30 ngày.',
    'Бизнес будет удалён через 30 дней. Запрашивайте после завершения всех броней. Отмена возможна в течение 30 дней.',
  ],
  deletionSubmit: ['탈퇴 요청', 'Submit request', 'Gửi yêu cầu', 'Отправить запрос'],
  deletionProcessing: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  deletionRequestFail: ['탈퇴 요청을 처리할 수 없어요.', 'Could not submit deletion request.', 'Không gửi được yêu cầu xóa.', 'Не удалось отправить запрос.'],
  deletionRequestSuccess: ['탈퇴 요청이 접수됐어요.', 'Deletion request submitted.', 'Đã gửi yêu cầu xóa.', 'Запрос на удаление принят.'],
  deletionRequestError: ['탈퇴 요청 실패', 'Deletion request failed', 'Yêu cầu xóa thất bại', 'Ошибка запроса'],
};

const staff = {
  inviteTitle: ['직원 초대', 'Invite staff', 'Mời nhân viên', 'Пригласить сотрудника'],
  inviteHint: [
    '밍고에 이미 가입한 사용자만 이메일로 초대할 수 있어요.',
    'You can invite anyone who already has a Mingo account, by email.',
    'Chỉ có thể mời người đã có tài khoản Mingo, qua email.',
    'Пригласить можно только тех, у кого уже есть аккаунт Mingo, по email.',
  ],
  emailPlaceholder: ['이메일 주소', 'Email address', 'Địa chỉ email', 'Электронная почта'],
  inviteBtn: ['초대하기', 'Invite', 'Mời', 'Пригласить'],
  inviting: ['초대 중…', 'Inviting…', 'Đang mời…', 'Приглашение…'],
  inviteSuccess: ['직원을 초대했어요', 'Staff invited', 'Đã mời nhân viên', 'Сотрудник приглашён'],
  listTitle: ['직원 목록', 'Staff members', 'Danh sách nhân viên', 'Сотрудники'],
  listEmpty: ['등록된 직원이 없어요', 'No staff yet', 'Chưa có nhân viên', 'Пока нет сотрудников'],
  memberFallback: ['(이름 없음)', '(No name)', '(Chưa có tên)', '(Без имени)'],
  ownerLocked: ['대표', 'Owner', 'Chủ sở hữu', 'Владелец'],
  removeBtn: ['제거', 'Remove', 'Xóa', 'Удалить'],
  removeSuccess: ['직원을 제거했어요', 'Staff removed', 'Đã xóa nhân viên', 'Сотрудник удалён'],
  roleOwner: ['대표', 'Owner', 'Chủ sở hữu', 'Владелец'],
  roleAdmin: ['관리자', 'Admin', 'Quản trị', 'Администратор'],
  roleManager: ['매니저', 'Manager', 'Quản lý', 'Менеджер'],
  roleStaff: ['직원', 'Staff', 'Nhân viên', 'Сотрудник'],
  errorUserNotFound: [
    '가입된 사용자를 찾을 수 없어요. 이메일을 확인해주세요.',
    'No Mingo account found with that email.',
    'Không tìm thấy tài khoản Mingo với email này.',
    'Аккаунт Mingo с таким email не найден.',
  ],
  errorForbidden: ['이 작업을 할 권한이 없어요.', "You don't have permission to do this.", 'Bạn không có quyền thực hiện.', 'У вас нет прав на это действие.'],
  errorSelf: ['자기 자신은 초대할 수 없어요.', "You can't invite yourself.", 'Không thể tự mời chính mình.', 'Нельзя пригласить самого себя.'],
  errorOwner: ['대표 권한은 변경할 수 없어요.', "The owner's role can't be changed.", 'Không thể đổi quyền của chủ sở hữu.', 'Роль владельца изменить нельзя.'],
  errorGeneric: ['처리에 실패했어요.', 'Something went wrong.', 'Đã xảy ra lỗi.', 'Что-то пошло не так.'],
};

const catalog = {
  noCatalogTitle: [
    '이 업종은 상품 등록 대신 견적·채팅으로 운영해요',
    'This industry uses quotes and chat instead of product listings.',
    'Ngành này dùng báo giá & chat thay vì đăng sản phẩm.',
    'В этой категории — котировки и чат, без каталога.',
  ],
  noCatalogSub: [
    '프로필과 채팅 문의로 고객을 받을 수 있어요.',
    'Get customers through your profile and chat.',
    'Tiếp khách qua hồ sơ và chat.',
    'Клиенты через профиль и чат.',
  ],
  title: ['상품 관리', 'Listings', 'Quản lý sản phẩm', 'Товары'],
  titleService: ['서비스 관리', 'Services', 'Quản lý dịch vụ', 'Услуги'],
  addListing: ['+ 상품 등록', '+ Add listing', '+ Đăng sản phẩm', '+ Добавить'],
  addListingService: ['+ 서비스 등록', '+ Add service', '+ Đăng dịch vụ', '+ Добавить услугу'],
  statusAria: ['상품 상태', 'Listing status', 'Trạng thái', 'Статус'],
  typeAria: ['업종 유형', 'Listing type', 'Loại', 'Тип'],
  allTypes: ['전체 유형', 'All types', 'Tất cả loại', 'Все типы'],
  limitBanner: [
    '무료 플랜은 상품 {max}개까지 등록할 수 있어요. 패키지·숙소는 유료 플랜에서 가능해요.',
    'Free plan: up to {max} listings. Packages & stays require a paid plan.',
    'Gói miễn phí: tối đa {max} sản phẩm. Gói & lưu trú cần gói trả phí.',
    'Бесплатно: до {max} позиций. Пакеты и жильё — платный план.',
  ],
  emptyTitle: ['아직 등록된 상품이 없어요', 'No listings yet', 'Chưa có sản phẩm', 'Пока нет товаров'],
  emptyTitleService: ['아직 등록된 서비스가 없어요', 'No services yet', 'Chưa có dịch vụ', 'Пока нет услуг'],
  emptySub: ['상품을 등록하면 허브에 노출돼요', 'Listings appear in the hub', 'Sản phẩm hiển thị trên hub', 'Товары появятся в хабе'],
  emptySubService: ['서비스를 등록하면 허브에 노출돼요', 'Services appear in the hub', 'Dịch vụ hiển thị trên hub', 'Услуги появятся в хабе'],
  filterEmpty: ['선택한 조건의 상품이 없어요', 'No listings match filters', 'Không có sản phẩm phù hợp', 'Нет подходящих товаров'],
  searchPh: [
    '메뉴·상품 이름 검색',
    'Search by name',
    'Tìm theo tên món/sản phẩm',
    'Поиск по названию',
  ],
  searchAria: ['상품 검색', 'Search listings', 'Tìm sản phẩm', 'Поиск товаров'],
  categoryAria: ['메뉴 카테고리', 'Menu categories', 'Danh mục thực đơn', 'Категории меню'],
  categoryAll: ['전체', 'All', 'Tất cả', 'Все'],
  categoryUncategorized: ['미분류', 'Uncategorized', 'Chưa phân loại', 'Без категории'],
  filterAria: ['상품 필터', 'Listing filters', 'Bộ lọc sản phẩm', 'Фильтры товаров'],
  filterAll: ['전체', 'All', 'Tất cả', 'Все'],
  filterPopular: ['인기', 'Popular', 'Phổ biến', 'Популярное'],
  filterDiscount: ['할인', 'On sale', 'Giảm giá', 'Скидка'],
  filterFeatured: ['추천', 'Recommended', 'Đề xuất', 'Рекомендуем'],
  filterSoldOut: ['품절', 'Sold out', 'Hết hàng', 'Нет в наличии'],
  metaViews: ['조회 {views} · 문의 {inquiries} · 예약 {bookings}', 'Views {views} · Inquiries {inquiries} · Bookings {bookings}', 'Xem {views} · Hỏi {inquiries} · Đặt {bookings}', 'Просмотры {views} · Запросы {inquiries} · Брони {bookings}'],
  comboBadge: ['콤보', 'Combo', 'Gói combo', 'Комбо'],
  edit: ['수정', 'Edit', 'Sửa', 'Изменить'],
  hide: ['숨김', 'Hide', 'Ẩn', 'Скрыть'],
  publish: ['공개', 'Publish', 'Công khai', 'Опубликовать'],
  duplicating: ['복제 중…', 'Duplicating…', 'Đang nhân bản…', 'Копирование…'],
  duplicate: ['복제', 'Duplicate', 'Nhân bản', 'Копировать'],
  view: ['보기', 'View', 'Xem', 'Открыть'],
  delete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  deleting: ['삭제 중…', 'Deleting…', 'Đang xóa…', 'Удаление…'],
  itemBookings: ['이 상품 예약자', 'Bookings for this item', 'Đặt chỗ của mục này', 'Брони по позиции'],
  typeModalTitle: ['상품 유형 선택', 'Choose listing type', 'Chọn loại sản phẩm', 'Тип товара'],
  cafeEntryModalTitle: ['무엇으로 등록할까요?', 'What are you registering?', 'Bạn muốn đăng gì?', 'Что вы регистрируете?'],
  cafeEntryModalHint: [
    '음료·디저트처럼 주문 시 옵션이 붙는 항목은 메뉴로, 원두·텀블러처럼 재고로 관리하는 항목은 상품으로 등록하세요.',
    'Drinks/desserts with order-time options go under Menu. Retail items you track by stock (beans, tumblers) go under Product.',
    'Đồ uống/tráng miệng có tùy chọn khi đặt hàng thì đăng ở Menu. Hàng bán lẻ theo tồn kho (cà phê hạt, bình nước) thì đăng ở Sản phẩm.',
    'Напитки/десерты с опциями при заказе — в Меню. Розничные товары со складским учётом (кофе в зёрнах, термосы) — в Товары.',
  ],
  cafeEntryAsMenu: ['메뉴로 등록', 'Register as menu', 'Đăng theo Menu', 'Регистрировать как меню'],
  cafeEntryAsProduct: ['상품으로 등록', 'Register as product', 'Đăng theo Sản phẩm', 'Регистрировать как товар'],
  proTypeHint: [
    '패키지·숙소 등 일부 유형은 유료 플랜에서 등록할 수 있어요.',
    'Some types (packages, stays) require a paid plan.',
    'Một số loại (gói, lưu trú) cần gói trả phí.',
    'Пакеты и жильё — только на платном плане.',
  ],
  limitModalTitle: ['상품 등록 한도', 'Listing limit', 'Giới hạn đăng', 'Лимит товаров'],
  limitModalBody: [
    '무료 플랜은 상품 {max}개까지 등록할 수 있어요.\n기존 상품을 삭제하거나 유료 플랜으로 업그레이드하세요.',
    'Free plan allows up to {max} listings.\nDelete items or upgrade to a paid plan.',
    'Gói miễn phí: tối đa {max} sản phẩm.\nXóa mục cũ hoặc nâng cấp gói.',
    'Бесплатно: до {max} позиций.\nУдалите старые или смените план.',
  ],
  viewPaidPlan: ['유료 플랜 보기', 'View paid plans', 'Xem gói trả phí', 'Платные планы'],
  proOnlyToast: [
    '패키지·숙소는 유료 플랜에서만 등록할 수 있어요.',
    'Packages and stays require a paid plan.',
    'Gói & lưu trú chỉ trên gói trả phí.',
    'Пакеты и жильё — только платный план.',
  ],
  statusChangeFail: ['상태 변경에 실패했어요.', 'Could not update status.', 'Không đổi được trạng thái.', 'Не удалось изменить статус.'],
  duplicateSuccess: ['상품이 복제됐어요. 임시저장 상태예요.', 'Listing duplicated as draft.', 'Đã nhân bản (bản nháp).', 'Копия сохранена как черновик.'],
  duplicateFail: ['복제 실패', 'Duplicate failed', 'Nhân bản thất bại', 'Ошибка копирования'],
  deleteConfirm: [
    '이 상품을 삭제할까요? 삭제하면 목록에서 바로 사라져요.',
    'Delete this listing? It will disappear from the list right away.',
    'Xóa sản phẩm này? Sản phẩm sẽ biến mất khỏi danh sách ngay.',
    'Удалить этот товар? Он сразу исчезнет из списка.',
  ],
  deleteSuccess: ['상품을 삭제했어요', 'Listing deleted', 'Đã xóa sản phẩm', 'Товар удалён'],
  deleteFail: ['삭제에 실패했어요', 'Failed to delete', 'Xóa thất bại', 'Не удалось удалить'],
  statusAll: ['전체', 'All', 'Tất cả', 'Все'],
  statusPublished: ['공개중', 'Published', 'Đang hiển thị', 'Опубликовано'],
  statusHidden: ['숨김', 'Hidden', 'Ẩn', 'Скрыто'],
  statusDraft: ['임시저장', 'Draft', 'Nháp', 'Черновик'],
  statusPendingReview: ['검수중', 'In review', 'Đang duyệt', 'На проверке'],
  statusSuspended: ['반려됨', 'Rejected', 'Từ chối', 'Отклонено'],
  statusArchived: ['종료', 'Archived', 'Lưu trữ', 'В архиве'],
  statusPaused: ['일시중단', 'Paused', 'Tạm dừng', 'Приостановлено'],
  statusSoldOut: ['마감', 'Sold out', 'Hết chỗ', 'Распродано'],
  statusDeleted: ['삭제됨', 'Deleted', 'Đã xóa', 'Удалено'],
  typeTour: ['단품 투어', 'Single tour', 'Tour lẻ', 'Тур'],
  typePackage: ['패키지', 'Package', 'Gói', 'Пакет'],
  typeAccommodation: ['숙소', 'Stay', 'Lưu trú', 'Жильё'],
  typeProperty: ['부동산', 'Property', 'BĐS', 'Недвижимость'],
  typeMenu: ['메뉴', 'Menu', 'Thực đơn', 'Меню'],
  typeClass: ['수업', 'Class', 'Lớp học', 'Занятие'],
  typeService: ['서비스', 'Service', 'Dịch vụ', 'Услуга'],
  typeJob: ['구인공고', 'Job post', 'Tuyển dụng', 'Вакансия'],
  typeSimPlan: ['유심/이심 요금제', 'SIM/eSIM plan', 'Gói SIM/eSIM', 'Тариф SIM/eSIM'],
  typeRental: ['차량 렌탈', 'Vehicle rental', 'Cho thuê xe', 'Аренда транспорта'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

const menuCategories = {
  manageBtn: ['카테고리 관리', 'Manage categories', 'Quản lý danh mục', 'Категории'],
  title: ['메뉴 카테고리 관리', 'Manage menu categories', 'Quản lý danh mục menu', 'Управление категориями меню'],
  hint: [
    '메뉴 이름이 아니라, 메뉴들을 묶는 큰 분류예요. 직접 만들고 순서를 정하세요 (예: 메인메뉴, 커피, 디저트)',
    "Not dish names — groups that several menu items belong to. Create your own and set their order (e.g. Main, Coffee, Dessert)",
    'Không phải tên món — đây là nhóm gồm nhiều món. Tự tạo và sắp xếp thứ tự (vd: Món chính, Cà phê, Tráng miệng)',
    'Это не названия блюд, а группы для нескольких позиций. Создайте свои категории и задайте порядок (напр. Основное, Кофе, Десерты)',
  ],
  empty: [
    '아직 카테고리가 없어요. 아래에서 추가해보세요.',
    "You haven't added any categories yet. Add one below.",
    'Chưa có danh mục nào. Thêm ở bên dưới.',
    'Категорий пока нет. Добавьте ниже.',
  ],
  addPlaceholder: ['새 카테고리 이름', 'New category name', 'Tên danh mục mới', 'Название новой категории'],
  addBtn: ['추가', 'Add', 'Thêm', 'Добавить'],
  moveUp: ['위로', 'Move up', 'Lên', 'Вверх'],
  moveDown: ['아래로', 'Move down', 'Xuống', 'Вниз'],
  remove: ['삭제', 'Remove', 'Xóa', 'Удалить'],
  saveBtn: ['저장', 'Save', 'Lưu', 'Сохранить'],
  saving: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  saveSuccess: ['카테고리를 저장했어요', 'Categories saved', 'Đã lưu danh mục', 'Категории сохранены'],
  saveFail: ['저장에 실패했어요', 'Failed to save', 'Lưu thất bại', 'Не удалось сохранить'],
  uncategorized: ['기타', 'Other', 'Khác', 'Другое'],
};

const couponModal = {
  openBtn: ['+ 쿠폰 만들기', '+ Create coupon', '+ Tạo mã giảm giá', '+ Создать купон'],
  titleSuffix: ['쿠폰을 만들고 있어요', 'Creating a coupon', 'Đang tạo mã giảm giá', 'Создание купона'],
  typeAmount: ['할인금액', 'Fixed discount', 'Giảm số tiền', 'Скидка суммой'],
  typePercent: ['할인율', 'Percent off', 'Giảm phần trăm', 'Скидка в процентах'],
  typeShipping: ['배송비 할인', 'Free shipping', 'Miễn phí ship', 'Бесплатная доставка'],
  typeGift: ['무료 증정', 'Free gift', 'Quà tặng', 'Подарок'],
  typeUpgrade: ['업그레이드', 'Upgrade', 'Nâng cấp', 'Апгрейд'],
  titlePlaceholder: ['쿠폰 제목 (최대 17자)', 'Coupon title (up to 17 chars)', 'Tên mã giảm giá (tối đa 17 ký tự)', 'Название купона (до 17 симв.)'],
  productNamePlaceholder: ['상품명 (최대 7자)', 'Item name (up to 7 chars)', 'Tên sản phẩm (tối đa 7 ký tự)', 'Название товара (до 7 симв.)'],
  amountPlaceholder: ['할인 금액', 'Discount amount', 'Số tiền giảm', 'Сумма скидки'],
  percentSuffix: ['%', '%', '%', '%'],
  periodLabel: ['응모 기간', 'Campaign period', 'Thời gian áp dụng', 'Период акции'],
  periodThisMonth: ['이번달', 'This month', 'Tháng này', 'Этот месяц'],
  periodNextMonth: ['다음달', 'Next month', 'Tháng sau', 'Следующий месяц'],
  periodThisYear: ['올해', 'This year', 'Năm nay', 'Этот год'],
  periodCustom: ['입력', 'Custom', 'Tùy chỉnh', 'Свой период'],
  periodStartLabel: ['시작일', 'Start date', 'Ngày bắt đầu', 'Дата начала'],
  periodEndLabel: ['종료일', 'End date', 'Ngày kết thúc', 'Дата окончания'],
  quantityLabel: ['발급 수량', 'Quantity to issue', 'Số lượng phát hành', 'Количество купонов'],
  quantityHint: ['설정한 수량만큼만 발급돼요', 'Only this many coupons will be issued', 'Chỉ phát hành đúng số lượng đã đặt', 'Будет выпущено только это количество'],
  qty100: ['100개', '100 coupons', '100 mã', '100 купонов'],
  qty500: ['500개', '500 coupons', '500 mã', '500 купонов'],
  qty1000: ['1,000개', '1,000 coupons', '1.000 mã', '1 000 купонов'],
  qtyCustomPlaceholder: ['수량 입력', 'Enter quantity', 'Nhập số lượng', 'Введите количество'],
  descLabel: ['사용 설명', 'Usage instructions', 'Hướng dẫn sử dụng', 'Инструкция по использованию'],
  descDefault: [
    '📌 쿠폰 사용 방법\n1. 주문·방문 시 쿠폰 코드를 보여주세요.\n2. 직원이 코드를 확인하고 할인을 적용해드려요.\n3. 1인 1회, 다른 쿠폰과 중복 사용은 불가해요.',
    '📌 How to use\n1. Show the coupon code when ordering or visiting.\n2. Staff will verify the code and apply the discount.\n3. Once per customer, cannot be combined with other coupons.',
    '📌 Cách sử dụng\n1. Xuất trình mã giảm giá khi đặt hàng hoặc ghé thăm.\n2. Nhân viên sẽ kiểm tra mã và áp dụng giảm giá.\n3. Mỗi khách 1 lần, không dùng chung với mã khác.',
    '📌 Как использовать\n1. Покажите код купона при заказе или посещении.\n2. Сотрудник проверит код и применит скидку.\n3. Один раз на клиента, не сочетается с другими купонами.',
  ],
  imagePickTitle: ['이미지 선택', 'Choose image', 'Chọn hình ảnh', 'Выбор изображения'],
  entryImageLabel: ['응모 이미지', 'Campaign image', 'Hình ảnh áp dụng', 'Изображение акции'],
  winImageLabel: ['당첨 이미지', 'Reward image', 'Hình ảnh khi trúng', 'Изображение награды'],
  imageHint: ['jpg, png (최대 10MB)', 'jpg, png (up to 10MB)', 'jpg, png (tối đa 10MB)', 'jpg, png (до 10МБ)'],
  sameImageLabel: [
    '응모 이미지와 당첨 이미지 동일 사용',
    'Use the same image for reward',
    'Dùng chung hình ảnh áp dụng và trúng thưởng',
    'Использовать то же изображение для награды',
  ],
  imageConfirmBtn: ['확인', 'Confirm', 'Xác nhận', 'Подтвердить'],
  uploading: ['업로드 중…', 'Uploading…', 'Đang tải lên…', 'Загрузка…'],
  uploadFail: ['이미지 업로드에 실패했어요', 'Failed to upload image', 'Tải ảnh lên thất bại', 'Не удалось загрузить изображение'],
  presetBenefit: ['혜택 안내', 'Benefit info', 'Thông tin ưu đãi', 'О преимуществах'],
  presetFirstVisit: ['첫 방문 할인', 'First visit', 'Ưu đãi lần đầu', 'Первый визит'],
  presetBirthday: ['생일 축하 할인', 'Birthday discount', 'Ưu đãi sinh nhật', 'Скидка на день рождения'],
  presetEvent: ['할인 이벤트', 'Discount event', 'Sự kiện giảm giá', 'Акция'],
  presetRevisit: ['재방문 할인', 'Return visit', 'Ưu đãi quay lại', 'Скидка за повторный визит'],
  draftBtn: ['임시저장', 'Save draft', 'Lưu nháp', 'Сохранить черновик'],
  createBtn: ['만들기', 'Create', 'Tạo', 'Создать'],
  saving: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  titleRequired: ['제목을 입력해주세요', 'Please enter a title', 'Vui lòng nhập tên', 'Введите название'],
  valueRequired: ['할인 값을 입력해주세요', 'Please enter a discount value', 'Vui lòng nhập giá trị giảm giá', 'Введите размер скидки'],
  codeLabel: ['쿠폰 번호', 'Coupon number', 'Mã số giảm giá', 'Номер купона'],
  codeHint: ['{n}자리 숫자로 자동 발급', 'Auto-generated {n}-digit code', 'Tự động cấp mã {n} chữ số', 'Автоматически {n}-значный код'],
  codeModeUnique: [
    '당첨자별 다른 번호로 발급',
    'Different number per winner',
    'Cấp số khác nhau cho mỗi người trúng',
    'Разный номер для каждого победителя',
  ],
  codeModeShared: [
    '모두 동일한 번호로 발급',
    'Same number for everyone',
    'Cấp cùng một số cho tất cả',
    'Один номер для всех',
  ],
  codeInputPlaceholder: [
    '쿠폰 번호 (최대 24자 영문, 숫자)',
    'Coupon number (up to 24 letters/digits)',
    'Mã số (tối đa 24 ký tự chữ và số)',
    'Номер купона (до 24 букв/цифр)',
  ],
  winRateLabel: ['당첨 확률', 'Win probability', 'Tỷ lệ trúng thưởng', 'Вероятность выигрыша'],
  winRateHint: [
    '100%선택시 선착순 지급',
    'At 100%, given first-come first-served',
    'Chọn 100% sẽ tặng theo thứ tự đăng ký',
    'При 100% выдаётся в порядке очереди',
  ],
  winRateCustomPlaceholder: ['확률 입력', 'Enter probability', 'Nhập tỷ lệ', 'Введите вероятность'],
  usageExpiryLabel: ['사용 만료일', 'Usage expiry date', 'Ngày hết hạn sử dụng', 'Дата истечения использования'],
  usageExpiryHint: [
    '{date} 이후 쿠폰 사용 불가',
    'Cannot be used after {date}',
    'Không thể sử dụng sau {date}',
    'Нельзя использовать после {date}',
  ],
  usageExpirySame: ['응모 종료일과 동일', 'Same as campaign end date', 'Giống ngày kết thúc áp dụng', 'Как дата окончания акции'],
  usageExpiryCustom: ['입력', 'Custom', 'Tùy chỉnh', 'Указать дату'],
  calendarConfirm: ['{date} 선택', 'Select {date}', 'Chọn {date}', 'Выбрать {date}'],
};

const foodStats = {
  title: ['주문 통계', 'Order stats', 'Thống kê đơn hàng', 'Статистика заказов'],
  periodLabel: ['최근 {n}일', 'Last {n} days', '{n} ngày gần đây', 'Последние {n} дн.'],
  totalRevenue: ['총 매출', 'Total revenue', 'Tổng doanh thu', 'Общая выручка'],
  totalOrders: ['총 주문건수', 'Total orders', 'Tổng đơn hàng', 'Всего заказов'],
  ordersUnit: ['{n}건', '{n} orders', '{n} đơn', '{n} заказов'],
  cancelRate: ['취소율', 'Cancel rate', 'Tỷ lệ hủy', 'Доля отмен'],
  cancelRateSub: ['{cancelled}/{total}건', '{cancelled}/{total} orders', '{cancelled}/{total} đơn', '{cancelled}/{total} заказов'],
  dailyChartTitle: ['일별 매출/주문', 'Daily revenue & orders', 'Doanh thu & đơn hàng theo ngày', 'Выручка и заказы по дням'],
  dailyEmpty: ['최근 데이터가 없어요', 'No recent data', 'Chưa có dữ liệu gần đây', 'Нет недавних данных'],
  popularTitle: ['인기 메뉴 TOP5', 'Top 5 popular items', 'Top 5 món bán chạy', 'Топ-5 популярных блюд'],
  popularEmpty: ['완료된 주문이 아직 없어요', 'No completed orders yet', 'Chưa có đơn hoàn tất', 'Пока нет завершённых заказов'],
  soldUnit: ['{n}개 판매', '{n} sold', 'Đã bán {n}', 'Продано {n}'],
  hourlyChartTitle: ['시간대별 주문 분포', 'Orders by hour', 'Đơn hàng theo giờ', 'Заказы по часам'],
  hourlyEmpty: ['최근 데이터가 없어요', 'No recent data', 'Chưa có dữ liệu gần đây', 'Нет недавних данных'],
  hourlyTooltip: ['{hour}시 · {n}건', '{hour}:00 · {n} orders', '{hour}h · {n} đơn', '{hour}:00 · {n} заказов'],
  hourTick: ['{hour}시', '{hour}h', '{hour} giờ', '{hour}ч'],
  loadError: ['통계를 불러오지 못했어요', 'Could not load stats', 'Không tải được thống kê', 'Не удалось загрузить статистику'],
  tab_revenue: ['매출', 'Revenue', 'Doanh thu', 'Выручка'],
  tab_orders: ['주문', 'Orders', 'Đơn hàng', 'Заказы'],
  tab_popular: ['인기메뉴', 'Popular items', 'Món bán chạy', 'Популярное'],
  tab_hourly: ['시간대', 'By hour', 'Theo giờ', 'По часам'],
  tab_report: ['리포트', 'Report', 'Báo cáo', 'Отчёт'],
  legendRevenue: ['매출', 'Revenue', 'Doanh thu', 'Выручка'],
  legendOrders: ['주문건수', 'Orders', 'Số đơn', 'Заказы'],
  legendHourly: ['주문건수', 'Orders', 'Số đơn', 'Заказы'],
  popularHint: ['최근 30일 · 완료 주문 기준', 'Last 30 days · completed orders', '30 ngày gần đây · đơn đã hoàn tất', 'За 30 дней · завершённые заказы'],
  narrativeNoPrev: [
    '이번 기간 매출은 {revenue}입니다.\n비교할 지난 기간 데이터가 없어요.',
    'Revenue for this period is {revenue}.\nNo previous period to compare yet.',
    'Doanh thu kỳ này là {revenue}.\nChưa có dữ liệu kỳ trước để so sánh.',
    'Выручка за этот период — {revenue}.\nНет данных за прошлый период для сравнения.',
  ],
  narrativeRevenue: [
    '이번 기간 매출은 {revenue}입니다.\n지난 기간 대비 {pct}% {dir}했어요.',
    'Revenue for this period is {revenue}.\nThat is {pct}% {dir} vs. the previous period.',
    'Doanh thu kỳ này là {revenue}.\nĐã {dir} {pct}% so với kỳ trước.',
    'Выручка за этот период — {revenue}.\nЭто на {pct}% {dir} по сравнению с прошлым периодом.',
  ],
  narrativeUp: ['증가', 'up', 'tăng', 'больше'],
  narrativeDown: ['감소', 'down', 'giảm', 'меньше'],
};

const industryPlaceholder = {
  showcasesTitle: ['시공 사례·포트폴리오', 'Project gallery & portfolio', 'Thư viện dự án & portfolio', 'Галерея работ и портфолио'],
  showcasesSub: [
    '프로필 사진과 소개에서 사례를 보여줄 수 있어요. 전용 갤러리는 곧 연결됩니다.',
    'Show work via profile photos and bio. A dedicated gallery will connect soon.',
    'Bạn có thể trưng bày qua ảnh hồ sơ và giới thiệu. Thư viện riêng sẽ sớm kết nối.',
    'Покажите работы в фото профиля и описании. Отдельная галерея скоро подключится.',
  ],
  manageProfileCta: ['프로필·사진 관리', 'Manage profile & photos', 'Quản lý hồ sơ & ảnh', 'Профиль и фото'],
  inquiriesTitle: ['견적·상담', 'Quotes & consults', 'Báo giá & tư vấn', 'Сметы и консультации'],
  consultTitle: ['상담 문의', 'Consult inquiries', 'Yêu cầu tư vấn', 'Консультации'],
  inquiriesSub: [
    '고객 문의는 채팅 탭에서 확인하고 답장할 수 있어요.',
    'Check and reply to customer inquiries in the Chat tab.',
    'Bạn có thể xem và trả lời tin nhắn khách ở tab Chat.',
    'Отвечайте на запросы клиентов во вкладке «Чат».',
  ],
  openChatCta: ['채팅 열기', 'Open chat', 'Mở chat', 'Открыть чат'],
  menuPreparing: ['이 메뉴는 준비 중이에요.', 'This menu is coming soon.', 'Menu này sắp có.', 'Этот раздел скоро появится.'],
  applicantsTitle: ['지원자 관리', 'Applicants', 'Ứng viên', 'Кандидаты'],
  applicantsSub: [
    '지원자 전용 목록은 아직 준비 중이에요. 지원 문의는 채팅 탭에서 확인하고 답장할 수 있어요.',
    'A dedicated applicants list is coming soon. For now, check and reply to applicants in the Chat tab.',
    'Danh sách ứng viên riêng sắp ra mắt. Hiện tại bạn có thể xem và trả lời ứng viên ở tab Chat.',
    'Отдельный список кандидатов скоро появится. Пока отвечайте кандидатам во вкладке «Чат».',
  ],
};

const jobsBusiness = {
  jobsTitle: ['내 채용공고', 'My job posts', 'Tin tuyển dụng của tôi', 'Мои вакансии'],
  jobsSub: [
    '올린 구인 공고를 관리해요. 지원자는 각 공고 상세에서 확인할 수 있어요.',
    'Manage your job posts. View applicants on each post’s detail page.',
    'Quản lý tin tuyển dụng. Xem ứng viên ở trang chi tiết từng tin.',
    'Управляйте вакансиями. Кандидатов смотрите на странице объявления.',
  ],
  applicantsTitle: ['지원자 확인', 'Check applicants', 'Xem ứng viên', 'Кандидаты'],
  applicantsSub: [
    '공고를 열면 지원자 목록과 이력서를 볼 수 있어요.',
    'Open a post to see applicants and resumes.',
    'Mở tin để xem danh sách ứng viên và hồ sơ.',
    'Откройте вакансию, чтобы увидеть отклики и резюме.',
  ],
  createCta: ['공고 등록', 'Post a job', 'Đăng tin', 'Разместить'],
  emptyTitle: ['아직 올린 공고가 없어요', 'No job posts yet', 'Chưa có tin tuyển dụng', 'Пока нет вакансий'],
  emptySub: [
    '첫 구인 공고를 올려 지원자를 받아보세요.',
    'Post your first opening to start receiving applicants.',
    'Đăng tin tuyển dụng đầu tiên để nhận ứng viên.',
    'Опубликуйте первую вакансию, чтобы получать отклики.',
  ],
  statusActive: ['모집중', 'Open', 'Đang tuyển', 'Открыта'],
  statusInactive: ['비활성', 'Inactive', 'Không hoạt động', 'Неактивна'],
  openDetail: ['공고 상세 보기', 'View post', 'Xem chi tiết', 'Открыть'],
  openApplicants: ['지원자 보기', 'View applicants', 'Xem ứng viên', 'Кандидаты'],
  openBoard: ['구인구직 게시판 열기', 'Open jobs board', 'Mở bảng tin việc', 'Открыть доску вакансий'],
  recommendCta: ['🎯 추천 인재 보기', '🎯 See recommended talent', '🎯 Xem nhân tài đề xuất', '🎯 Рекомендуемые кандидаты'],
  recommendHide: ['접기', 'Hide', 'Thu gọn', 'Скрыть'],
  recommendLoading: ['추천 인재를 찾는 중…', 'Finding recommended talent…', 'Đang tìm nhân tài phù hợp…', 'Подбираем кандидатов…'],
  recommendEmpty: [
    '아직 조건에 맞는 공개 인재가 없어요.',
    'No matching public talent profiles yet.',
    'Chưa có hồ sơ nhân tài phù hợp.',
    'Пока нет подходящих кандидатов.',
  ],
  recommendMatch: ['{score}점 매칭', 'Match {score}', 'Khớp {score}', 'Совпадение {score}'],
  repostCta: ['이 공고로 다시 올리기', 'Post again from this', 'Đăng lại từ tin này', 'Опубликовать снова'],
  loadSavedForm: ['저장된 공고 폼 불러오기', 'Load saved job form', 'Tải form tin đã lưu', 'Загрузить сохранённую форму'],
  savedFormHint: [
    '직종·급여·근무조건이 그대로 채워져요. 제목·마감일만 확인하고 등록하세요.',
    'Occupation, pay and hours are filled in. Check the title and deadline, then publish.',
    'Ngành, lương và giờ làm được điền sẵn. Kiểm tra tiêu đề & hạn rồi đăng.',
    'Должность, оплата и график подставятся. Проверьте заголовок и срок, затем опубликуйте.',
  ],
  loadedToast: [
    '지난 공고를 불러왔어요. 마감일을 다시 정한 뒤 등록하세요.',
    'Loaded a previous post. Set a new deadline, then publish.',
    'Đã tải tin trước. Đặt hạn mới rồi đăng.',
    'Загружено прошлое объявление. Укажите новый срок и опубликуйте.',
  ],
};

const showcase = {
  title: ['업체 사진첩', 'Business photos', 'Album ảnh cửa hàng', 'Фотоальбом бизнеса'],
  sub: [
    '외부·내부·시설 등 카테고리별 사진을 올리면 소개 페이지에 탭으로 보여요.',
    'Upload photos by category (exterior, interior, facilities…) — they show as tabs on your intro page.',
    'Tải ảnh theo danh mục (ngoại thất, nội thất, tiện ích…) — sẽ hiển thị dạng tab trên trang giới thiệu.',
    'Загрузите фото по категориям (экстерьер, интерьер, удобства…) — они появятся как вкладки на странице профиля.',
  ],
  hint: [
    '카테고리를 선택하고 사진을 추가하세요. 자동 저장됩니다.',
    'Pick a category and add photos. Changes save automatically.',
    'Chọn danh mục và thêm ảnh. Tự động lưu.',
    'Выберите категорию и добавьте фото. Сохраняется автоматически.',
  ],
  saveError: [
    '저장에 실패했어요. 다시 시도해 주세요.',
    'Could not save. Please try again.',
    'Lưu thất bại. Vui lòng thử lại.',
    'Не удалось сохранить. Попробуйте ещё раз.',
  ],
  category: {
    exterior: ['외부', 'Exterior', 'Ngoại thất', 'Экстерьер'],
    interior: ['내부', 'Interior', 'Nội thất', 'Интерьер'],
    facility: ['시설', 'Facilities', 'Tiện ích', 'Удобства'],
    restroom: ['화장실', 'Restroom', 'Nhà vệ sinh', 'Туалет'],
    other: ['기타', 'Other', 'Khác', 'Другое'],
  },
};

function pickCategory(langIndex) {
  const out = {};
  Object.entries(showcase.category).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    dashboard: {
      home: pick(home, langIndex),
      fab: pick(fab, langIndex),
      more: pick(more, langIndex),
      staff: pick(staff, langIndex),
      catalog: pick(catalog, langIndex),
      chat: pick(chat, langIndex),
      reviews: pick(reviews, langIndex),
      shorts: pick(shorts, langIndex),
      menuCategories: pick(menuCategories, langIndex),
      couponModal: pick(couponModal, langIndex),
      foodStats: pick(foodStats, langIndex),
      industryPlaceholder: pick(industryPlaceholder, langIndex),
      jobsBusiness: pick(jobsBusiness, langIndex),
      showcase: { ...pick({ title: showcase.title, sub: showcase.sub, hint: showcase.hint, saveError: showcase.saveError }, langIndex), category: pickCategory(langIndex) },
    },
  };
}

export const phaseE1Ko = buildLang(0);
export const phaseE1En = buildLang(1);
export const phaseE1Vi = buildLang(2);
export const phaseE1Ru = buildLang(3);

export const FAB_ACTION_LABEL_KEYS = {
  create_product: 'dashboard.fab.createProduct',
  create_booking: 'dashboard.fab.createBooking',
  create_promo: 'dashboard.fab.createPromo',
  create_consult: 'dashboard.fab.createConsult',
  create_content: 'dashboard.fab.createContent',
  create_job: 'dashboard.fab.createJob',
};

export const CATALOG_STATUS_TAB_KEYS = [
  { key: 'all', labelKey: 'dashboard.catalog.statusAll' },
  { key: 'published', labelKey: 'dashboard.catalog.statusPublished' },
  { key: 'hidden', labelKey: 'dashboard.catalog.statusHidden' },
  { key: 'draft', labelKey: 'dashboard.catalog.statusDraft' },
  { key: 'pending_review', labelKey: 'dashboard.catalog.statusPendingReview' },
  { key: 'suspended', labelKey: 'dashboard.catalog.statusSuspended' },
  { key: 'archived', labelKey: 'dashboard.catalog.statusArchived' },
];

export const CATALOG_STATUS_LABEL_KEYS = {
  draft: 'dashboard.catalog.statusDraft',
  pending_review: 'dashboard.catalog.statusPendingReview',
  published: 'dashboard.catalog.statusPublished',
  hidden: 'dashboard.catalog.statusHidden',
  paused: 'dashboard.catalog.statusPaused',
  suspended: 'dashboard.catalog.statusSuspended',
  sold_out: 'dashboard.catalog.statusSoldOut',
  archived: 'dashboard.catalog.statusArchived',
  deleted: 'dashboard.catalog.statusDeleted',
};

export const CATALOG_TYPE_LABEL_KEYS = {
  tour: 'dashboard.catalog.typeTour',
  package: 'dashboard.catalog.typePackage',
  accommodation: 'dashboard.catalog.typeAccommodation',
  property: 'dashboard.catalog.typeProperty',
  menu: 'dashboard.catalog.typeMenu',
  class: 'dashboard.catalog.typeClass',
  service: 'dashboard.catalog.typeService',
  job_posting: 'dashboard.catalog.typeJob',
};

export const MORE_MENU_KEYS = [
  { key: 'manage', icon: '👤', labelKey: 'dashboard.more.profileManage' },
  { key: 'reviews', icon: '⭐', labelKey: 'dashboard.more.reviewsManage' },
  { key: 'ads', icon: '📢', labelKey: 'dashboard.more.ads' },
  { key: 'shorts', icon: '🎬', labelKey: 'dashboard.more.shorts' },
  { key: 'overview', icon: '📊', labelKey: 'dashboard.more.overview' },
  { key: 'plan', icon: '💳', labelKey: 'dashboard.more.plan' },
  { key: 'staff', icon: '🧑‍🤝‍🧑', labelKey: 'dashboard.more.staffManage' },
  // jobs_business 업종은 하단탭(공고관리/지원자)에 이미 있어서 더보기에서는 숨김.
  // 리뷰/쇼츠도 매장형 UI라 MoreTab에서 함께 숨김.
  { key: 'hiring', icon: '💼', labelKey: 'dashboard.more.jobsManage' },
];
